import { useContext, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { IoIosClose } from 'react-icons/io';
import { toast } from 'react-toastify';

import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import Box from 'components/ui/box';
import { actionLog } from 'services/actionlog.service';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
  playerInfo?: any;
}

export default function ModalParticipantsAccept({ callback, status, id, data, playerInfo }: Props) {
  ReactModal.setAppElement('#modal');

  const modalID = 'validation-participants-accept';

  const { openModal, closeModal } = useModal();

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  async function registerLog() {
    if (sending) return false;

    setSending(true);

    try {
      const log = await actionLog('me', 'task_participants_approval', {
        taskId: id,
        approved: true,
        quantity: data?.team?.length,
      });

      setSending(false);
      document.dispatchEvent(new CustomEvent('reload:pendingapproval'));
      callback({ id: 'reload_task' });
      closeModal();

      toast.success(`Avaliação realizada com sucesso.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      toast.error(`Ocorreu um erro ao registrar sua ação. Por favor, tente novamente em alguns minutos.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setSending(false);
    }
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Avaliação"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 bg-black bg-opacity-60 flex flex-col items-center w-screen h-screen p-6 pt-[10vh] overflow-y-auto"
        contentElement={() => (
          <Box className={`w-[90%] lg:w-auto lg:max-w-[600px]`}>
            <Button
              color="primary"
              className="absolute -right-5 -top-5 rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
              onClick={() => (!sending ? closeModal() : null)}
            >
              <IoIosClose color="white" size={40} />
            </Button>

            <div className="w-full lg:w-[536px] flex flex-col items-center justify-center space-y-8">
              <h4 className="block text-center text-yellow text-lg font-semibold leading-none">
                Autorizar número de participantes na realização
              </h4>
              <p className="text-alice-blue text-base font-thin block">
                Você pode autorizar o número de participantes na realização para continuar com o fluxo de validação. Deseja
                confirmar essa ação?
              </p>
              <button
                className={`text-white bg-slate-blue text-sm inline-flex items-center justify-center font-semibold uppercase rounded py-3 px-4 leading-none ${
                  sending ? 'opacity-75' : ''
                }`}
                onClick={() => {
                  registerLog();
                }}
                disabled={sending}
              >
                CONFIRMAR
              </button>
            </div>
          </Box>
        )}
      />
    </>
  );
}
